var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M8.24983 1.54499C7.08429 1.68121 5.97858 2.13503 5.05339 2.85688C4.1282 3.57874 3.41911 4.54089 3.00351 5.63831C2.58792 6.73572 2.4818 7.92622 2.69674 9.07985C2.91168 10.2335 3.43941 11.3059 4.22233 12.18L7.49983 15.8175C7.68965 16.0268 7.92117 16.194 8.17951 16.3085C8.43784 16.423 8.71728 16.4821 8.99983 16.4821C9.28239 16.4821 9.56182 16.423 9.82016 16.3085C10.0785 16.194 10.31 16.0268 10.4998 15.8175L13.7623 12.18C14.6254 11.2102 15.1739 10.0014 15.3352 8.71321C15.4964 7.42505 15.2629 6.11828 14.6655 4.96569C14.0681 3.81311 13.1349 2.869 11.9893 2.25821C10.8438 1.64742 9.53978 1.39872 8.24983 1.54499ZM8.99983 10.3125C8.52336 10.314 8.05716 10.174 7.66026 9.9104C7.26336 9.64677 6.95362 9.27129 6.77025 8.83151C6.58688 8.39173 6.53814 7.90742 6.63018 7.43992C6.72223 6.97242 6.95093 6.54274 7.28732 6.2053C7.62371 5.86785 8.05268 5.63781 8.51989 5.54431C8.9871 5.45081 9.47155 5.49804 9.9119 5.68004C10.3523 5.86203 10.7287 6.1706 10.9936 6.56668C11.2584 6.96275 11.3998 7.42851 11.3998 7.90499C11.3998 8.5422 11.1472 9.15342 10.6973 9.6047C10.2475 10.056 9.63704 10.3105 8.99983 10.3125Z",
    fill: "#BBBBBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99984 10.3799C10.3999 10.3799 11.5348 9.24498 11.5348 7.84494C11.5348 6.44489 10.3999 5.30994 8.99984 5.30994C7.5998 5.30994 6.46484 6.44489 6.46484 7.84494C6.46484 9.24498 7.5998 10.3799 8.99984 10.3799Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.58807e3439e5bb14bdd00b83f3d621d3.svg";
export { ForwardRef as ReactComponent };